// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/projects.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/projects.proto.
 */
export const file_pull_requests_v1_projects: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/projects
 *
 * Defined by PullRequests::PageData::SharedController#projects.
 *
 * @generated from message github.pull_requests.v1.ProjectsResponse
 */
export type ProjectsResponse = Message<"github.pull_requests.v1.ProjectsResponse"> & {
  /**
   * The Projects (v2) this pull request is currently linked to.
   *
   * @generated from field: repeated github.pull_requests.v1.PullRequestProject projects = 1;
   */
  projects: PullRequestProject[];
};

/**
 * Describes the message github.pull_requests.v1.ProjectsResponse.
 * Use `create(ProjectsResponseSchema)` to create a new message.
 */
export const ProjectsResponseSchema: GenMessage<ProjectsResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 0);

/**
 * @generated from message github.pull_requests.v1.PullRequestProject
 */
export type PullRequestProject = Message<"github.pull_requests.v1.PullRequestProject"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: int32 number = 3;
   */
  number: number;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: bool closed = 5;
   */
  closed: boolean;

  /**
   * @generated from field: string item_id = 6;
   */
  itemId: string;

  /**
   * Whether the viewer has write access to this project, and so can change
   * its fields (e.g. status) for this item.
   *
   * @generated from field: bool viewer_can_update = 7;
   */
  viewerCanUpdate: boolean;

  /**
   * The project's "Status" single-select field and its value for this item,
   * if the project has one.
   *
   * @generated from field: github.pull_requests.v1.PullRequestProjectStatus status = 8;
   */
  status?: PullRequestProjectStatus;

  /**
   * Additional user-defined fields configured on this project (e.g. custom text, number, date,
   * single-select, multi-select, and iteration fields), in the project's configured display
   * order. This excludes the built-in "Status" field above. Corresponds to the "+N more" fields
   * shown below the status in the Rails sidebar's `issues/sidebar/_memex_project_item` partial.
   *
   * @generated from field: repeated github.pull_requests.v1.PullRequestProjectField fields = 9;
   */
  fields: PullRequestProjectField[];
};

/**
 * Describes the message github.pull_requests.v1.PullRequestProject.
 * Use `create(PullRequestProjectSchema)` to create a new message.
 */
export const PullRequestProjectSchema: GenMessage<PullRequestProject> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 1);

/**
 * @generated from message github.pull_requests.v1.PullRequestProjectStatus
 */
export type PullRequestProjectStatus = Message<"github.pull_requests.v1.PullRequestProjectStatus"> & {
  /**
   * Database id of the "Status" single-select field
   *
   * @generated from field: string field_id = 1;
   */
  fieldId: string;

  /**
   * Id of the currently selected option, if any.
   *
   * @generated from field: string option_id = 2;
   */
  optionId: string;

  /**
   * Options available to select from.
   *
   * @generated from field: repeated github.pull_requests.v1.PullRequestProjectStatusOption options = 3;
   */
  options: PullRequestProjectStatusOption[];
};

/**
 * Describes the message github.pull_requests.v1.PullRequestProjectStatus.
 * Use `create(PullRequestProjectStatusSchema)` to create a new message.
 */
export const PullRequestProjectStatusSchema: GenMessage<PullRequestProjectStatus> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 2);

/**
 * @generated from message github.pull_requests.v1.PullRequestProjectStatusOption
 */
export type PullRequestProjectStatusOption = Message<"github.pull_requests.v1.PullRequestProjectStatusOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestProjectStatusOption.
 * Use `create(PullRequestProjectStatusOptionSchema)` to create a new message.
 */
export const PullRequestProjectStatusOptionSchema: GenMessage<PullRequestProjectStatusOption> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 3);

/**
 * A custom, user-defined field on a project (a MemexProjectColumn) and its value for this item,
 * if any. Exactly one of the typed `*_value` fields below is meaningful, matching `type`.
 *
 * @generated from message github.pull_requests.v1.PullRequestProjectField
 */
export type PullRequestProjectField = Message<"github.pull_requests.v1.PullRequestProjectField"> & {
  /**
   * Database id of the field (MemexProjectColumn).
   *
   * @generated from field: string field_id = 1;
   */
  fieldId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: github.pull_requests.v1.PullRequestProjectFieldType type = 3;
   */
  type: PullRequestProjectFieldType;

  /**
   * Populated when type == PULL_REQUEST_PROJECT_FIELD_TYPE_TEXT.
   *
   * @generated from field: string text_value = 4;
   */
  textValue: string;

  /**
   * Populated when type == PULL_REQUEST_PROJECT_FIELD_TYPE_NUMBER.
   *
   * @generated from field: optional double number_value = 5;
   */
  numberValue?: number;

  /**
   * Populated when type == PULL_REQUEST_PROJECT_FIELD_TYPE_DATE. An ISO 8601 date (YYYY-MM-DD).
   *
   * @generated from field: string date_value = 6;
   */
  dateValue: string;

  /**
   * Populated when type == PULL_REQUEST_PROJECT_FIELD_TYPE_SINGLE_SELECT. Id of the currently
   * selected option, if any.
   *
   * @generated from field: string option_id = 7;
   */
  optionId: string;

  /**
   * Populated when type == PULL_REQUEST_PROJECT_FIELD_TYPE_MULTI_SELECT. Ids of the currently
   * selected options.
   *
   * @generated from field: repeated string option_ids = 8;
   */
  optionIds: string[];

  /**
   * Populated when type == PULL_REQUEST_PROJECT_FIELD_TYPE_ITERATION. Id of the currently
   * selected iteration, if any.
   *
   * @generated from field: string iteration_id = 9;
   */
  iterationId: string;

  /**
   * Options available to select from, when type == PULL_REQUEST_PROJECT_FIELD_TYPE_SINGLE_SELECT
   * or PULL_REQUEST_PROJECT_FIELD_TYPE_MULTI_SELECT.
   *
   * @generated from field: repeated github.pull_requests.v1.PullRequestProjectFieldOption options = 10;
   */
  options: PullRequestProjectFieldOption[];

  /**
   * Iterations available to select from, when type == PULL_REQUEST_PROJECT_FIELD_TYPE_ITERATION.
   *
   * @generated from field: repeated github.pull_requests.v1.PullRequestProjectFieldIteration iterations = 11;
   */
  iterations: PullRequestProjectFieldIteration[];
};

/**
 * Describes the message github.pull_requests.v1.PullRequestProjectField.
 * Use `create(PullRequestProjectFieldSchema)` to create a new message.
 */
export const PullRequestProjectFieldSchema: GenMessage<PullRequestProjectField> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 4);

/**
 * @generated from message github.pull_requests.v1.PullRequestProjectFieldOption
 */
export type PullRequestProjectFieldOption = Message<"github.pull_requests.v1.PullRequestProjectFieldOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestProjectFieldOption.
 * Use `create(PullRequestProjectFieldOptionSchema)` to create a new message.
 */
export const PullRequestProjectFieldOptionSchema: GenMessage<PullRequestProjectFieldOption> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 5);

/**
 * @generated from message github.pull_requests.v1.PullRequestProjectFieldIteration
 */
export type PullRequestProjectFieldIteration = Message<"github.pull_requests.v1.PullRequestProjectFieldIteration"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * ISO 8601 date (YYYY-MM-DD) on which the iteration starts.
   *
   * @generated from field: string start_date = 3;
   */
  startDate: string;

  /**
   * @generated from field: int32 duration_days = 4;
   */
  durationDays: number;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestProjectFieldIteration.
 * Use `create(PullRequestProjectFieldIterationSchema)` to create a new message.
 */
export const PullRequestProjectFieldIterationSchema: GenMessage<PullRequestProjectFieldIteration> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 6);

/**
 * @generated from enum github.pull_requests.v1.PullRequestProjectFieldType
 */
export enum PullRequestProjectFieldType {
  /**
   * @generated from enum value: PULL_REQUEST_PROJECT_FIELD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PULL_REQUEST_PROJECT_FIELD_TYPE_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: PULL_REQUEST_PROJECT_FIELD_TYPE_NUMBER = 2;
   */
  NUMBER = 2,

  /**
   * @generated from enum value: PULL_REQUEST_PROJECT_FIELD_TYPE_DATE = 3;
   */
  DATE = 3,

  /**
   * @generated from enum value: PULL_REQUEST_PROJECT_FIELD_TYPE_SINGLE_SELECT = 4;
   */
  SINGLE_SELECT = 4,

  /**
   * @generated from enum value: PULL_REQUEST_PROJECT_FIELD_TYPE_MULTI_SELECT = 5;
   */
  MULTI_SELECT = 5,

  /**
   * @generated from enum value: PULL_REQUEST_PROJECT_FIELD_TYPE_ITERATION = 6;
   */
  ITERATION = 6,
}

/**
 * Describes the enum github.pull_requests.v1.PullRequestProjectFieldType.
 */
export const PullRequestProjectFieldTypeSchema: GenEnum<PullRequestProjectFieldType> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_projects, 0);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(ProjectsResponseSchema, "31fb69462c5c")
registerSchemaHash(PullRequestProjectSchema, "e387ee9df426")
registerSchemaHash(PullRequestProjectStatusSchema, "72e02ee87a72")
registerSchemaHash(PullRequestProjectStatusOptionSchema, "826ff9c94d4d")
registerSchemaHash(PullRequestProjectFieldSchema, "2fbfe5f8ce09")
registerSchemaHash(PullRequestProjectFieldOptionSchema, "a21cf51d56a1")
registerSchemaHash(PullRequestProjectFieldIterationSchema, "4df113dbe5a7")
